const financialDeposit = [
  {
    path: '/financial/deposits',
    name: 'Deposits',
    redirect: { name: 'OpenDeposits' },
    meta: {
      auth: true,
      roles: ['Director', 'SalesExecutive', 'Manager', 'Analyst', 'Financial', 'Logistics', 'Seller', 'CreditAnalyst'],
    },
    component: () => import('@/_backoffice/_financial/components/deposit/Deposits'),
    children: [
      {
        meta: {
          auth: true,
          roles: ['Director', 'SalesExecutive', 'Manager', 'Analyst', 'Financial', 'Logistics', 'Seller', 'CreditAnalyst'],
        },
        path: '/financial/deposits/open',
        name: 'OpenDeposits',
        component: () => import('@/_backoffice/_financial/components/deposit/OpenDeposits'),
      },
    ]
  },
  {
    path: '/financial/deposits/create',
    name: 'NewDeposit',
    meta: {
      auth: true,
      roles: ['Director', 'SalesExecutive', 'Manager', 'Analyst', 'Financial', 'Logistics', 'Seller', 'CreditAnalyst'],
    },
    component: () => import('@/_backoffice/_financial/components/order_payment/NewDeposit'),
  }
]

export default financialDeposit
